import { render } from "./PersonRegistrationTagLoginView.vue?vue&type=template&id=6441d66e&scoped=true&ts=true"
import script from "./PersonRegistrationTagLoginView.vue?vue&type=script&lang=ts"
export * from "./PersonRegistrationTagLoginView.vue?vue&type=script&lang=ts"

import "./PersonRegistrationTagLoginView.vue?vue&type=style&index=0&id=6441d66e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6441d66e"]])

export default __exports__